import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CTASectionProps {
  onOpenDemo: () => void;
}
export function CTASection({
  onOpenDemo
}: CTASectionProps) {
  return <section className="bg-stark-white py-24 md:py-32" data-id="element-21" data-mp="2cep1gkjvmt4p">
      <div className="max-w-7xl mx-auto px-6" data-id="element-22" data-mp="2hetjwg4chxxk">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="relative bg-royal-blue rounded-2xl px-8 py-16 md:px-20 md:py-24 overflow-hidden text-center" data-id="element-23" data-mp="2hfmk0y8stp6q">
          <div aria-hidden="true" className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/10 pointer-events-none" data-id="element-24" data-mp="354e7xdfcvldp" />
          <div aria-hidden="true" className="absolute -bottom-32 -left-16 w-80 h-80 rounded-full bg-midnight-navy/20 pointer-events-none" data-id="element-25" data-mp="3a3qrnpaxkcc2" />

          <div className="relative z-10 max-w-3xl mx-auto space-y-8" data-id="element-26" data-mp="1w63zsr4r6zze">
            <h2 className="text-stark-white text-3xl md:text-5xl font-montserrat font-extrabold leading-tight tracking-tight" data-id="element-27" data-mp="1r7ivafigxu55">
              Ready to Increase Your ROI?
            </h2>
            <p className="text-stark-white/80 text-lg md:text-xl" data-id="element-28" data-mp="2jwq2e2vzns20">
              Schedule your free discovery call and see where your business is
              leaving money on the table.
            </p>
            <button onClick={onOpenDemo} className="group inline-flex items-center gap-2 bg-stark-white text-royal-blue px-10 py-5 rounded-full text-lg font-extrabold hover:bg-cool-gray transition-all shadow-2xl shadow-midnight-navy/20 active:scale-95" data-id="element-29" data-mp="2a6ofhefdgfoo">
              Schedule a Consultation
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-30" data-mp="2xvg09kqmtvrf" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}